// src/components/Dashboard/PlayerDashboard/MyClubsWidget.jsx
// Shows clubs the player is a member of

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBuilding, FaArrowRight, FaSearch } from 'react-icons/fa';
import styles from './MyClubsWidget.module.css';

const MyClubsWidget = ({ clubs, enrolledPrograms, onExploreClick }) => {
  const navigate = useNavigate();

  // Get program count per club
  const getClubProgramCount = (clubId) => {
    return enrolledPrograms?.filter(p => {
      const pClubId = p.clubId?._id || p.clubId || p.club?._id || p.club;
      return String(pClubId) === String(clubId);
    }).length || 0;
  };

  const handleClubClick = (club) => {
    navigate(`/club/${club._id}`);
  };

  const uniqueClubs = clubs?.filter((club, index, self) => 
    club && club._id && self.findIndex(c => c?._id === club._id) === index
  ) || [];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <FaBuilding className={styles.headerIcon} />
          <h3 className={styles.headerTitle}>My Clubs</h3>
        </div>
        <div className={styles.headerRight}>
          <span className={styles.count}>{uniqueClubs.length}</span>
          <button className={styles.exploreBtn} onClick={onExploreClick}>
            <FaSearch /> Find More
          </button>
        </div>
      </div>

      <div className={styles.content}>
        {uniqueClubs.length === 0 ? (
          <div className={styles.emptyState}>
            <span className={styles.emptyIcon}>🏆</span>
            <p>No clubs joined yet</p>
            <button className={styles.exploreButton} onClick={onExploreClick}>
              Explore Clubs <FaArrowRight />
            </button>
          </div>
        ) : (
          <div className={styles.clubsGrid}>
            {uniqueClubs.map((club, index) => {
              const programCount = getClubProgramCount(club._id);
              return (
                <div 
                  key={club._id || index}
                  className={styles.clubCard}
                  onClick={() => handleClubClick(club)}
                >
                  <div className={styles.clubLogo}>
                    {club.clubLogo || club.logo ? (
                      <img src={club.clubLogo || club.logo} alt="" />
                    ) : (
                      '🏆'
                    )}
                  </div>
                  <div className={styles.clubInfo}>
                    <span className={styles.clubName}>{club.name}</span>
                    <span className={styles.clubMeta}>
                      {programCount} {programCount === 1 ? 'program' : 'programs'}
                    </span>
                  </div>
                  <FaArrowRight className={styles.clubArrow} />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyClubsWidget;



